import type { CustomIconProps } from '../types';

const NavigationArrowLeft = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '6'}
        height={height || '12'}
        viewBox="0 0 6 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.86658 0.135181C6.04447 0.315423 6.04447 0.607653 5.86658 0.787895L1.04447 5.67364C0.866579 5.85389 0.866579 6.14612 1.04447 6.32636L5.86658 11.2121C6.04447 11.3923 6.04447 11.6846 5.86658 11.8648C5.68868 12.0451 5.40026 12.0451 5.22237 11.8648L0.400262 6.97907C-0.133421 6.43834 -0.13342 5.56165 0.400262 5.02093L5.22237 0.135181C5.40026 -0.0450605 5.68868 -0.0450605 5.86658 0.135181Z"
            fill="#414042"
        />
    </svg>
);

export default NavigationArrowLeft;
